<div class="faq-container mat-elevation-z2">

    <!-- 🔍 Search -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Buscar en todas las preguntas y respuestas</mat-label>
      <input matInput [(ngModel)]="searchTerm" placeholder="Ej. ASISA, NIE, renovación..." />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  
    <!-- Filters (optional - you already have them if you want) -->
    <div class="faq-filters">
      <mat-form-field appearance="outline">
        <mat-label>Categoría</mat-label>
        <mat-select [(ngModel)]="selectedCategory">
          <mat-option *ngFor="let cat of categories" [value]="cat">{{ cat }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  
    <!-- FAQ Accordion -->
    <mat-accordion multi>
      <mat-expansion-panel *ngFor="let faq of filteredFaqs">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ faq.question }}</mat-panel-title>
          <mat-panel-description *ngIf="faq.isPremium">
            <mat-icon color="warn">lock</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
  
        <div *ngIf="!faq.isPremium || (isLoggedIn && hasPremium)">
          <p>{{ faq.answer }}</p>
        </div>
  
        <div *ngIf="faq.isPremium && (!isLoggedIn || !hasPremium)">
          <p class="locked-message">Este contenido es exclusivo para usuarios premium.</p>
          <button mat-raised-button color="primary">Actualizar a Premium</button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  
  </div>
  